import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '@ge/components/button';
import { Icon, Icons } from '@ge/components/icon';
import { Dialog } from '@ge/components/modal';

const AttachmentContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
`;

const UploadContainer = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.fileUpload.backgroundColor};
  border: 1px dashed ${({ theme }) => theme.fileUpload.borderColor};
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  padding: 16px;
  }
`;

const FooterDivider = styled.div`
  border-top: 1px solid black;
  margin: 20px -26px 0px;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const FooterButtons = styled.div`
  margin-left: auto;
  margin-top: 15px;
  button:not(:last-of-type) {
    margin-right: 25px;
  }
`;

const EmailIcon = styled(Icon).attrs((props) => ({
  size: 11,
  icon: Icons.EMAIL,
  color: props.theme.entityDetails.headerIconColor,
}))`
  margin-right: 4px;
`;

const StyledDialog = styled(Dialog)`
  width: 565px;
`;

const PrivacyPolicyDialog = ({ isOpen, onClose }) => {
  const [isLoading] = useState(false);

  const { t } = useTranslation(['general']);

  const handleCloseDialog = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <>
      <StyledDialog
        emailHeaderIcon={<EmailIcon />}
        isOpen={isOpen}
        onClose={handleCloseDialog}
        header={'Privacy Policy'}
      >
        <AttachmentContainer>
          <UploadContainer>{t('privacy_policy', 'privacy_policy')}</UploadContainer>
        </AttachmentContainer>

        <FooterDivider></FooterDivider>
        <FooterContainer>
          <FooterButtons>
            <Button onClick={handleCloseDialog} disabled={isLoading}>
              {'Close'}
            </Button>
          </FooterButtons>
        </FooterContainer>
      </StyledDialog>
    </>
  );
};

PrivacyPolicyDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  emailHeaderIcon: PropTypes.node,
};

export default PrivacyPolicyDialog;
